import { supabase } from './supabaseClient';
import { loadCustomTexts } from '../utils/storage';

/**
 * ログイン後：ローカルとクラウドのカスタムテキストをマージして同期
 * ローカルにしかないものをクラウドに追加し、クラウドにしかないものをローカルに追加する
 */
export async function syncCustomTextsOnLogin(familyId) {
  if (!familyId) return;
  try {
    const { data, error } = await supabase
      .from('families')
      .select('custom_texts')
      .eq('id', familyId)
      .single();

    if (error) return;

    const cloud = data?.custom_texts || [];
    const local = loadCustomTexts();

    // IDベースで重複排除してマージ
    const cloudIds = new Set(cloud.map((t) => t.id));
    const localOnly = local.filter((t) => !cloudIds.has(t.id));
    const merged = [...cloud, ...localOnly];

    // マージ結果をローカルとクラウド両方に保存
    localStorage.setItem('ondoku_custom_texts', JSON.stringify(merged));
    await supabase
      .from('families')
      .update({ custom_texts: merged })
      .eq('id', familyId);
  } catch (e) {
    console.warn('カスタムテキスト同期エラー:', e);
  }
}

/**
 * ローカルの最新状態をクラウドに保存（保存・更新・削除後に呼ぶ）
 */
export async function pushCustomTextsToCloud(familyId) {
  if (!familyId) return;
  try {
    const texts = loadCustomTexts();
    await supabase
      .from('families')
      .update({ custom_texts: texts })
      .eq('id', familyId);
  } catch (e) {
    console.warn('カスタムテキストクラウド保存エラー:', e);
  }
}
